const nav = document.querySelector("#main-nav");
const navbarMenu = document.querySelector(".navbar-menu");
const menuBtn = document.querySelector("#mobile-menu-btn");
const overlay = document.querySelector(".overlay");


if (nav) {

  const toggleMenu = () => {
    navbarMenu.classList.toggle("open");
    overlay.classList.toggle("open");
    menuBtn.classList.toggle("open");
  }

  const closeMenu = () => {
    navbarMenu.classList.remove("open");
    overlay.classList.remove("open");
    menuBtn.classList.remove("open");
  }


  document.addEventListener("keyup", function(e) {
    if (e.key === "Escape") closeMenu();
  });

  document.addEventListener("click", function() {
    if (navbarMenu.classList.contains("open")) {
      overlay.classList.add("open");
    }
  });

  const mq = window.matchMedia("screen and (min-width: 1024px)");

  mq.addEventListener("change", event => {
    if (event.matches) {
      closeMenu();
    }
  })

  menuBtn.addEventListener("click", toggleMenu);
  overlay.addEventListener("click", closeMenu);

}
